import { Component, Input, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { LMBuilderContext, LMBuilderEvent, LMBuilderModel } from "@components/builder/services/lm-builder-model.service";
import { CdkDrag, CdkDragDrop, CdkDropList } from "@angular/cdk/drag-drop";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector:    'lm-builder-display-fields',
  standalone: false,
  templateUrl: './lm-builder-display-fields.component.html',
  styleUrl: './lm-builder-display-fields.component.scss',
})
export class LMBuilderDisplayFieldsComponent implements OnInit, OnDestroy {
  @Input() spec!: LMListPSpec;

  private readonly destroyer$ = new Subject<void>();
  protected readonly LMBuilderModel = LMBuilderModel;

  _showDetail: WritableSignal<boolean> = signal(false);
  _selectedDisplayField: WritableSignal<LMDisplayFieldPSpec | undefined> = signal(undefined);

  constructor(
    protected lmBuilderModel: LMBuilderModel
  ) {
  }
  ngOnInit(): void {
    this.lmBuilderModel.builderEvent$.pipe(
        takeUntil(this.destroyer$))
        .subscribe(event => {
          this.handleModelEvent(event);
        });

    this.lmBuilderModel.builderContext$.pipe(
        takeUntil(this.destroyer$))
        .subscribe(builderContext => {
      this.handleBuilderContextChange(builderContext);
    });
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  private handleModelEvent(event:LMBuilderEvent) {
    if (event === LMBuilderEvent.DISPLAY_FIELD_ADDED || event === LMBuilderEvent.DISPLAY_FIELD_REMOVED) {
      // this.initialize();
    }
  }

  private handleBuilderContextChange(builderContext: LMBuilderContext) {
    if (builderContext === 'DISPLAY_FIELDS' && this._showDetail()) {
      this.lmBuilderModel.builderContext$.next('UNKNOWN');
    }
  }

  canDrop = (drag: CdkDrag, drop: CdkDropList): boolean => {
    if (drag.dropContainer.data.includes('lm-builder-field')) {
      return this.lmBuilderModel.allowColumnField(drag.data);
    } else if (drag.dropContainer.data.includes(LMBuilderModel.DISPLAY_FIELDS_LIST)) {
      return true;
    }

    return false;
  };

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.data.includes('lm-builder-field')) {
      if (this.lmBuilderModel.allowColumnField(event.item.data)) {
        this.lmBuilderModel.addDisplayField(event.currentIndex, event.item.data);
      }
    } else if (event.previousContainer.data.includes(LMBuilderModel.DISPLAY_FIELDS_LIST)) {
      this.lmBuilderModel.reorderDisplayField(event.currentIndex, event.previousIndex, event.item.data);
    }
  }

  showDetail(displayField: LMDisplayFieldPSpec) {
    this._showDetail.set(true);
    this.lmBuilderModel.builderContext$.next("UNKNOWN");
    this._selectedDisplayField.set(displayField);
  }

  showCardDetail() {
    this._showDetail.set(true);
    this.lmBuilderModel.builderContext$.next("UNKNOWN");
  }

  hideDetail() {
    this._showDetail.set(false);
    this.lmBuilderModel.builderContext$.next("DISPLAY_FIELDS");
    this._selectedDisplayField.set(undefined);
  }

  removeDisplayField(index: number, displayField: LMDisplayFieldPSpec) {
    this.lmBuilderModel.removeDisplayField(index, displayField);
  }

  addComputeDisplayField() {
   const displayField = this.lmBuilderModel.addComputeDisplayField();

   if (displayField) {
     this.showDetail(displayField);
   }
  }
}
